import actions from '@/config/actions';
import Api from '@/config/api';
import mutations from '@/config/mutations';
import axios from '@/http';
import store from '@/store';
import router from '@/router';

// let refreshingToken = false;
// let tokenRefreshPromise = null;
export default {
  login(username, password, isNewPanel = true) {
    return axios.post(Api.endpoints.TOKEN, {
      grant_type: Api.credentials.grantTypes.PASSWORD,
      client_id: Api.credentials.CLIENT_ID,
      client_secret: Api.credentials.CLIENT_SECRET,
      // client_secret: '$2a$10$1NwRagFIRFUah0eC5HLtQuN5Sv9I4MHGm5yFoRwZB6E9dV7Xw06dW',
      username,
      password,
      isNewPanel,
    });
  },

  setToken(token) {
    if (!token) {
      localStorage.removeItem('token_v2');
      // Clear sessionStorage for user preferences
      sessionStorage.removeItem('showJdSection');
      store.commit('clearAll');
      store.commit('clearTemplate');
      store.commit('jd/clearAll');
      store.commit('jd/clearAllJds');
    } else localStorage.setItem('token_v2', JSON.stringify(token));
  },

  getToken() {
    const token = JSON.parse(localStorage.getItem('token_v2'));
    // if (token && this.hasTokenExpired(token)) {
    //    console.log(this.refreshToken(token));
    //    return this.refreshToken(token);
    // }
    if (token && this.hasTokenExpired(token)) {
      store.commit(mutations.auth.SET_TOKEN, null);
      this.setToken();
      return null;
      // return this.refreshToken(token);
    }
    if (!token || this.hasTokenExpired(token)) {
      store.commit(mutations.auth.SET_TOKEN, null);
      this.setToken();
      return null;
    }
    // if (this.isTokenExpiring(token)) {
    //   this.refreshToken(token);
    // }
    store.commit(mutations.auth.SET_TOKEN, token);
    return token;
  },

  isLoggedIn() {
    const token = this.getToken();
    return Boolean(token);
  },

  isTokenExpiring(token) {
    const tokenLifetime = token.expires_in;
    return tokenLifetime - this.getTokenAge(token) < 100;
  },

  hasTokenExpired(token) {
    const tokenLifetime = token.expires_in;
    return tokenLifetime - this.getTokenAge(token) < 5;
  },

  getTokenAge(token) {
    const currentDate = Date.now();
    return (currentDate - token.created_at) / 1000;
  },
  logout() {
    router.push({ name: 'logout' });
  },

  // refreshToken(token) {
  //     return axios
  //       .post(Api.endpoints.TOKEN, {
  //       grant_type: Api.credentials.grantTypes.REFRESH_TOKEN,
  //       client_id: Api.credentials.CLIENT_ID,
  //       client_secret: Api.credentials.CLIENT_SECRET,
  //       refresh_token: token.refresh_token,
  //     })
  //     .then(({ data: newToken }) => {
  //       store.dispatch(actions.auth.LOGGED_IN, newToken);
  //     })
  //     .catch(() => {
  //       // this.setToken(null);
  //       this.logout();
  //     });
  // },

  // refreshToken(token) {
  //   if (refreshingToken) {
  //     return new Promise((resolve, reject) => {
  //       const interval = setInterval(() => {
  //         if (!refreshingToken) {
  //           clearInterval(interval);
  //           console.log('Token refresh completed. Retrieving token...');
  //           tokenRefreshPromise = null;
  //           resolve(this.getToken());
  //         }
  //       }, 100);
  //     });
  //   }

  //   refreshingToken = true;

  //   return axios
  //     .post(Api.endpoints.TOKEN, {
  //       grant_type: Api.credentials.grantTypes.REFRESH_TOKEN,
  //       client_id: Api.credentials.CLIENT_ID,
  //       client_secret: Api.credentials.CLIENT_SECRET,
  //       refresh_token: token.refresh_token,
  //     })
  //     .then(response => {
  //       const newToken = response.data;
  //       store.dispatch(actions.auth.LOGGED_IN, newToken);
  //       this.setToken(newToken);
  //       refreshingToken = false;

  //       return newToken;
  //     })
  //     .catch(error => {
  //       // console.log(error);
  //       refreshingToken = false;
  //       // store.commit(mutations.auth.SET_TOKEN, null);
  //       // this.setToken(null);
  //       this.logout();
  //       // throw error;
  //     });
  // }
};
